import styled, { css } from 'styled-components'

import { Box } from '../../../../shared_components/UI/Box'

const accordianIcon = require('../../../../styles/images/accordian-arrow.svg')

export const Grid = styled.div<{ gridRef?: any }>`
  position: relative;

  margin-left: -210px;
  @media screen and (max-width: 1000px) {
    margin-left: 0px;
  }
`

export const Video = styled.video`
  height: 452px;
  width: 100%;
  @media screen and (max-width: 1000px) {
    height: auto;
  }
`

export const Markdown = styled.div<{ isTopBar?: boolean }>`
  img {
    margin: 32px auto;
    max-width: 800px;
    @media screen and (max-width: 800px) {
      max-width: calc(100vw - 64px);
    }
  }
  li {
    font-style: normal;
    font-weight: normal;
    ${({ isTopBar }) =>
      isTopBar &&
      css`
        color: #fffcfc;
      `}
    margin: 16px 0;
    padding-left: 16px;
  }
  h1 {
    font-style: normal;
    font-weight: normal;
    font-size: 36px;
    line-height: 41px;
    margin: 16px 0;
    ${({ isTopBar }) =>
      isTopBar &&
      css`
        color: #fffcfc;
      `}
  }
  h2 {
    font-style: normal;
    font-weight: normal;
    font-size: 28px;
    line-height: 32px;
    margin: 16px 0;
    ${({ isTopBar }) =>
      isTopBar &&
      css`
        color: #fffcfc;
      `}
  }
  h3,
  h4,
  h5,
  h6,
  p,
  span {
    margin: 16px 0;
    ${({ isTopBar }) =>
      isTopBar &&
      css`
        color: #fffcfc;
      `}
  }
  li:before {
    content: '■';
    position: absolute;
    left: 210px;
    font-size: 0.4em;
    /* top: 4px; */
    padding-top: 7px;
    @media screen and (max-width: 767px) {
      left: 0px;
    }
  }
`

export const NavColumn = styled(Box)`
  flex-direction: column;
  position: absolute;
  width: 210px;
  transition: 0.05s ease-in-out;
  @media screen and (max-width: 1900px) {
    opacity: 0;
    pointer-events: none;
  }
`

export const NavLink = styled.span<{ isActive: boolean }>`
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 20px;
  transition: 0.3s ease-in-out;
  cursor: pointer;
  text-transform: uppercase;
  margin: 6px 0;
  transition: opacity 0.3s ease-in-out;
  max-width: 180px;
  color: ${({ isActive, theme }) =>
    isActive ? theme.colors.textPrimary : '#fff'};

  opacity: ${({ isActive }) => (isActive ? 1 : 0.3)};
  :hover {
    color: ${({ theme }) => theme.colors.textPrimary};
  }
`

export const BodyContainer = styled.div`
  width: calc(100% - 210px - 410px);
  padding-right: 16px;
  margin-left: 210px;
  margin-top: -28px;
  padding-bottom: 80px;
  @media screen and (max-width: 1000px) {
    margin-top: 0px;
    margin-left: 0;
    width: 100%;
    padding-right: 0;
  }
`

export const Section = styled.div`
  width: 100%;
`

export const Desktop = styled.div`
  display: none;
  @media screen and (min-width: 1000px) {
    display: flex;
  }
`

export const Mobile = styled.div<{ hasMargin?: boolean }>`
  display: none;
  @media screen and (max-width: 1000px) {
    display: flex;
    margin-bottom: ${({ hasMargin }) => (!hasMargin ? -32 : 0)}px;
    flex-direction: column;
  }
`

export const AccordianArrow = styled.div<{ isOpen: boolean | null }>`
  justify-self: flex-end;
  background-image: url(${accordianIcon.default});
  background-repeat: no-repeat;
  width: 14px;
  height: 14px;
  padding: 8px;
  margin-top: 4px;
  transition: 0.1s ease-in-out;
  transform: rotate(${({ isOpen }) => (isOpen ? 0 : -90)}deg);
`

export const AccordianTab = styled(Box)<{
  align?: string
  maxHeight?: string
}>`
  align-items: ${({ align }) => align ?? 'flex-start'};
  justify-content: space-between;
  margin-top: ${({ maxHeight }) => (maxHeight ? 0 : 64)}px;
  margin-bottom: 16px;
  max-height: ${({ maxHeight }) => maxHeight ?? '100%'};
  @media screen and (max-width: 1000px) {
    margin-top: ${({ maxHeight }) => (maxHeight ? 0 : 48)}px;
  }
`

export const Seperator = styled.div`
  width: 100%;
  background: #c4c4c4;
  opacity: 0.3;
  height: 1px;
  margin-bottom: 16px;
`

export const ContentWrapper = styled.div<{ isOpen: boolean }>`
  max-height: ${({ isOpen }) => (isOpen ? 2000 : 0)}px;
  transition: 0.2s ease-in-out;
  overflow: hidden;
  position: relative;
`
